import { Vector3 } from "three";
import React, { useEffect, useState } from "react";
import Paneel from "../../doors/paneel";
import Schuif from "../../doors/schuif";
import { ConfigurationProps } from "../../Door";
import { useConfigurationOptionsContext } from "../../../../../app/providers/DoorOptionsProvider";

interface DoubleSchuifSinglePanelProps extends ConfigurationProps {}
const DoubleSchuifSinglePanel: React.FC<DoubleSchuifSinglePanelProps> = ({
  materials,
  position,
  rotation,
  scale,
  doorSettings,
}: DoubleSchuifSinglePanelProps) => {
  const position0 = new Vector3(-0.459, 0, 0.04);
  const position1 = new Vector3(0.459, 0, 0.04);
  const position2 = new Vector3(1.377, 0, 0);

  const { eigenwijs, getConfigurationPositions } =
    useConfigurationOptionsContext();

  const [positions, setPositions] = useState<Vector3[]>([]);

  useEffect(() => {
    setPositions(getConfigurationPositions([position0, position1, position2]));
  }, [eigenwijs?.sizeObjects]);

  return (
    <group position={position} scale={scale}>
      <group scale-y={0.993}>
        <Schuif
          materials={materials}
          position={positions[0]}
          rotation={rotation}
          index={0}
          frameSettings={doorSettings?.secondary?.frameSettings}
          railSettings={doorSettings?.secondary?.railSettings}
        />
        <Schuif
          materials={materials}
          position={positions[1]}
          index={1}
          frameSettings={doorSettings?.main?.frameSettings}
          railSettings={doorSettings?.main?.railSettings}
        />
        <Paneel
          materials={materials}
          position={positions[2]}
          index={2}
          frameSettings={doorSettings?.tertiary?.frameSettings}
        />
      </group>
    </group>
  );
};

export default DoubleSchuifSinglePanel;
